<template>
  <div
    class="deck-row"
    :style="{
      'grid-template-columns': Array.from({ length: deckWidth })
        .map(() => 'auto')
        .join(' '),
    }"
  >
    <div
      v-for="(col, index) in Object.values(columns)"
      :key="`col:${numberedRow}:${index}`"
      class="deck-col"
    >
      <seat-map-block
        :obj="{
          ...getObject(col, index),
        }"
      />
    </div>
  </div>
</template>

<script>
import Block from '@liveflight/components/blocks/seat-map/seat-map-block.vue';

const EMPTY_SEAT = {
  type: 'empty',
};

export default {
  name: 'deck-row',
  props: {
    isExitRow: {
      type: Boolean,
      default: false,
    },
    currentTravelerChoosing: {
      type: String,
      default: () => '',
    },
    deckWidth: Number,
    rowObjects: Object,
    columns: Object,
    numberedRow: Number,
    selectedSeats: Object,
    handleSeatSelection: Function,
  },
  components: {
    'seat-map-block': Block,
  },
  methods: {
    getObject(col, index) {
      const type = this.isExitRow ? 'exits' : 'blocks';
      const elementsByType = this.rowObjects[type];
      if (!elementsByType) {
        return EMPTY_SEAT;
      }

      const elem = elementsByType[index];
      if (!elem) {
        return EMPTY_SEAT;
      }
      const obj = {
        ...elem,
        isExitRow: this.isExitRow,
        currentTravelerChoosing: this.currentTravelerChoosing,
        type: elem.type || 'empty',
      };
      if (obj.type === 'seat') {
        obj.passenger = this.selectedSeats[obj.number];
        obj.handleSeatSelection = this.handleSeatSelection;
      }
      if (this.numberedRow && col.isHallway && !this.isExitRow) {
        obj.row = this.numberedRow;
      }
      return obj;
    },
  },
};
</script>

<style lang="scss">
.deck-row {
  display: grid;
  gap: 5px;
  align-items: start;
}
.deck-col {
  line-height: 0;
  margin: 0;
  padding: 0;
}
</style>
